class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    const inputWhitelist = [".facet", ".collection-actions-wrapper"];

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.debouncedOnSubmitReduced = debounce(
      (event) => {
        this.onSubmitHandler(event);
      },
      250,
      true,
    );

    this.addEventListener("input", (event) => {
      if (
        event.target.classList.contains("otx-brand-search-input") ||
        event.target.type === "checkbox" ||
        event.target.type === "radio"
      ) {
        return;
      }

      if (!inputWhitelist.some((selector) => !!event.target.closest(selector))) {
        return false;
      }

      if (event.target.closest("price-range")) {
        this.debouncedOnSubmit(event);
      } else {
        this.debouncedOnSubmitReduced(event);
      }
    });

    this.addEventListener("change", (event) => {
      if (event.target.classList.contains("otx-brand-search-input")) {
        return;
      }
      if (!inputWhitelist.some((selector) => !!event.target.closest(selector))) {
        return false;
      }
      this.onSubmitHandler(event);
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) {
        return;
      }

      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, appendResults) {
    if (window.otozipApiActive) {
      if (typeof window.otozipSyncFilters === "function") {
        window.otozipSyncFilters();
      }
      return;
    }
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");

    if (countContainer) {
      countContainer.classList.add("loading");
    }

    // Optimistic loading state on mobile drawer
    const mobileDrawerSubmitBtn = document.querySelector(".button-sidebar-facets-submit");
    if (mobileDrawerSubmitBtn) {
      mobileDrawerSubmitBtn.classList.add("is-updating");
      if (!mobileDrawerSubmitBtn.hasAttribute("data-original-text")) {
        mobileDrawerSubmitBtn.setAttribute("data-original-text", mobileDrawerSubmitBtn.textContent.trim());
      }
      mobileDrawerSubmitBtn.textContent = "Memperbarui...";
    }
    const mobileCountNum = document.querySelector(".otx-sidebar-result-count-num");
    if (mobileCountNum) {
      mobileCountNum.classList.add("is-pulsing");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event, appendResults);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }

    if (!searchParams.includes("page")) {
      publish(PUB_SUB_EVENTS.collectionFilters, {
        filters: deserializeSearchParams(searchParams),
      });
    }
  }

  static getParsedDom(source) {
    if (typeof source === "string") {
      return new DOMParser().parseFromString(source, "text/html");
    }
    return source;
  }

  static resetMobileOptimisticState() {
    const mobileDrawerSubmitBtn = document.querySelector(".button-sidebar-facets-submit");
    if (mobileDrawerSubmitBtn) {
      mobileDrawerSubmitBtn.classList.remove("is-updating");
      const origText = mobileDrawerSubmitBtn.getAttribute("data-original-text") || "Terapkan";
      mobileDrawerSubmitBtn.textContent = origText;
    }
    const mobileCountNum = document.querySelector(".otx-sidebar-result-count-num");
    if (mobileCountNum) {
      mobileCountNum.classList.remove("is-pulsing");
    }
  }

  static renderSectionFromFetch(url, event, appendResults) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const parsedDom = new DOMParser().parseFromString(html, "text/html");
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, parsedDom, url }];
        FacetFiltersForm.renderCollectionActions(parsedDom);
        FacetFiltersForm.renderFilters(parsedDom, event);
        FacetFiltersForm.renderProductGridContainer(parsedDom, appendResults);
        FacetFiltersForm.renderProductCount(parsedDom);
        FacetFiltersForm.resetMobileOptimisticState();
      })
      .catch(() => {
        FacetFiltersForm.resetMobileOptimisticState();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const cached = FacetFiltersForm.filterData.find(filterDataUrl);
    let parsedDom = cached.parsedDom;
    if (!parsedDom) {
      parsedDom = new DOMParser().parseFromString(cached.html, "text/html");
      cached.parsedDom = parsedDom;
    }
    FacetFiltersForm.renderCollectionActions(parsedDom);
    FacetFiltersForm.renderFilters(parsedDom, event);
    FacetFiltersForm.renderProductGridContainer(parsedDom);
    FacetFiltersForm.renderProductCount(parsedDom);
    FacetFiltersForm.resetMobileOptimisticState();
  }

  static renderProductGridContainer(source, appendResults) {
    const container = document.getElementById("ProductGridContainer");
    const parsedDom = FacetFiltersForm.getParsedDom(source);

    if (appendResults) {
      parsedDom
        .getElementById("product-grid")
        .prepend(...[...document.getElementById("product-grid").childNodes]);
    }
    container.innerHTML = parsedDom.getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(source) {
    const parsedDom = FacetFiltersForm.getParsedDom(source);
    const count = parsedDom.getElementById("ProductCount")?.innerHTML;
    const container = document.getElementById("ProductCount");

    if (!container) {
      return;
    }

    container.innerHTML = count;
    container.classList.remove("loading");
  }

  static renderCollectionActions(source) {
    const container = document.getElementById("CollectionActions");
    const parsedDom = FacetFiltersForm.getParsedDom(source);

    if (!container) {
      return;
    }

    container.classList = parsedDom.getElementById("CollectionActions").classList;
  }

  static renderFilters(source, event) {
    const parsedHTML = FacetFiltersForm.getParsedDom(source);

    const oldFacetElements = document.querySelectorAll("#FacetFiltersForm .js-filter");

    const newFacetElements = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter");

    const expandedFacets = [];
    document
      .querySelectorAll('#FacetFiltersForm .js-filter collapsible-expandable[expanded="true"]')
      ?.forEach((node) => {
        const parent = node.closest(".js-filter");
        if (node.getAttribute("expanded")) {
          expandedFacets.push(parent.dataset.name);
        }
      });

    const facetsContainer = document.querySelector(
      "#FacetFiltersForm .page-layout-sidebar-inner-content",
    );
    const focusedElement = document.activeElement;
    let focusedFilterId = null;
    if (facetsContainer.contains(focusedElement)) {
      focusedFilterId = focusedElement.id;
    }

    const previousHeight = facetsContainer.getBoundingClientRect().height;
    facetsContainer.style.minHeight = `${previousHeight}px`;

    oldFacetElements.forEach((facet) => facet.remove());
    newFacetElements.forEach((element) => {
      const isExpanded = expandedFacets.includes(element.dataset.name);
      element.querySelector(".facet-toggle").setAttribute("aria-expanded", isExpanded);
      element.querySelector("collapsible-expandable").setAttribute("expanded", isExpanded);
      facetsContainer.append(element);
    });

    if (focusedFilterId) {
      document.getElementById(focusedFilterId)?.focus({ preventScroll: true });
    }

    requestAnimationFrame(() => {
      facetsContainer.style.minHeight = "";
    });

    const scrollTop = document.querySelector("facet-filters-form").dataset.scrollTop === "true";
    const container = document.getElementById("CollectionActions");
    if (
      scrollTop &&
      container &&
      window.innerWidth >= 990 &&
      !event?.target.name.includes(".price.")
    ) {
      const offset = document.querySelector("sticky-header:not([disabled])")?.offsetHeight ?? 0;
      const rect = container.getBoundingClientRect();
      const scrollPosition = window.scrollY + rect.top - offset;
      if (rect.top < 0) {
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });
      }
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".collection-actions-filters",
      ".otx-sidebar-active-chips",
      ".otx-sidebar-header-meta",
      ".otx-sidebar-reset-wrap",
      ".otx-sidebar-result-count-box",
      "#OtxActiveFilterCount"
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!activeFacetsElement || !targetElement) {
        return;
      }

      targetElement.innerHTML = activeFacetsElement.innerHTML;
      if (activeFacetsElement.hasAttribute("style")) {
        targetElement.setAttribute("style", activeFacetsElement.getAttribute("style"));
      } else {
        targetElement.removeAttribute("style");
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static updateURLHash(searchParams, replace) {
    if (replace) {
      history.replaceState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
      );
    } else {
      history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
      );
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(document.getElementById("FacetsFilterForm"));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    if (window.otozipApiActive) {
      if (typeof window.otozipResetSidebarFilters === "function") {
        window.otozipResetSidebarFilters(event);
      }
      return;
    }
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }

  onAjaxPagination(event) {
    event.preventDefault();
    const next = event.currentTarget;
    const url = next.href.indexOf("?") == -1 ? "" : next.href.slice(next.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url, event, true);
    scrollToElement(document.getElementById("ProductGridContainer"), -150);

    const params = new URLSearchParams(url);
    publish(PUB_SUB_EVENTS.pageChange, {
      page: Number(params.get("page")),
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

class AjaxPaginate extends HTMLElement {
  constructor() {
    super();
    const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
    const buttons = this.querySelectorAll("a");

    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        form.onAjaxPagination(event);
      });
    });
  }
}

customElements.define("ajax-paginate", AjaxPaginate);

function scrollToElement(element, offset) {
  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;
  window.scrollTo({
    top: absoluteElementTop + offset,
    behavior: "smooth",
  });
}

/**
 * Accepts a query string from faceted filtering and returns a
 * deserialized object.
 *
 * @param {string} queryString The query string.
 * @returns {{}}
 */
const deserializeSearchParams = (queryString) => {
  const params = new URLSearchParams(queryString);
  const result = {};

  for (const [key, value] of params.entries()) {
    if (result[key]) {
      result[key] = `${result[key]},${value}`;
    } else if (value) {
      result[key] = value;
    }
  }

  return result;
};





/* Automatic Instant DOM Deduplication & 'PCD x' Purge for PCD Option Filters */
(function deduplicatePcdFilterDom() {
  function dedup() {
    document.querySelectorAll('.facet-options-list').forEach(function(list) {
      var seen = {};
      list.querySelectorAll('.facet-options-list-item').forEach(function(item) {
        var labelEl = item.querySelector('.checkbox-facet-label-text') || item;
        var txt = (labelEl.textContent || '').trim();
        var txtLower = txt.toLowerCase();

        // 1. Immediately hide any 'PCD x' filter item
        if (txtLower.includes('pcd x') || txtLower.includes('pcdx')) {
          item.style.display = 'none';
          return;
        }
        
        // 2. Clean text mapping
        if (txt.includes('Lebaran')) txt = txt.replace(/Lebaran/g, 'Lebar');
        if (txt.includes('4x100') && txt.includes('114')) txt = 'PCD 4x100 / 4x114.3';
        else if (txt.includes('5x100') && txt.includes('114')) txt = 'PCD 5x100 / 5x114.3';
        else if (txt.includes('5x100') && txt.includes('112')) txt = 'PCD 5x100 / 5x112';
        else if (txt.includes('5x108') && txt.includes('112')) txt = 'PCD 5x108 / 5x112';
        else if (txt.includes('5x108') && txt.includes('114')) txt = 'PCD 5x108 / 5x114.3';
        else if (txt.includes('5x112') && txt.includes('114')) txt = 'PCD 5x112 / 5x114.3';
        else if (txt.includes('5x112') && txt.includes('120')) txt = 'PCD 5x112 / 5x120';
        else if (txt.includes('6x135') && txt.includes('139')) txt = 'PCD 6x135 / 6x139.7';
        else if (txt.includes('4x100')) txt = 'PCD 4x100';
        else if (txt.includes('114')) txt = 'PCD 4x114.3';
        else if (txt.includes('5x100')) txt = 'PCD 5x100';
        else if (txt.includes('5x108')) txt = 'PCD 5x108';
        else if (txt.includes('5x112')) txt = 'PCD 5x112';
        else if (txt.includes('5x120')) txt = 'PCD 5x120';
        else if (txt.includes('5x127')) txt = 'PCD 5x127';
        else if (txt.includes('139')) txt = 'PCD 6x139.7';

        if (labelEl && labelEl.textContent !== txt) {
          labelEl.textContent = txt;
        }

        if (seen[txt]) {
          item.style.display = 'none';
        } else {
          seen[txt] = true;
          item.style.display = '';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dedup);
  } else {
    dedup();
  }
  setTimeout(dedup, 100);
  setTimeout(dedup, 500);
  setTimeout(dedup, 1200);
  
  var observer = new MutationObserver(dedup);
  var target = document.getElementById('FacetFiltersForm') || document.body;
  if (target) {
    observer.observe(target, { childList: true, subtree: true });
  }
})();
